export const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';

export const getDrxAcsEndpoint = (year) => {
  return `${process.env.DRX_BASE}/${year}${process.env.DRX_ACS_SLUG}`;
};

export const getDrxDeepLink = (year) => {
  return `${process.env.DRX_BASE}/${year}`;
};
